import SalesDetailTabComponent from './SalesDetailTab';

const SalesDetailTab = SalesDetailTabComponent;

export default SalesDetailTab;
